import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const baseDocRuleURL = `api/v1/core-app/base-document-rules`;

//obtaining the paginated data
export const getBaseDocRule = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${baseDocRuleURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllBaseDocRule = () => axiosInstance.get(`${baseDocRuleURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageBaseDocRule = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${baseDocRuleURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

export const getBaseDocRuleById = (id) => axiosInstance.get(`${baseDocRuleURL}/retrieve/${id}`);

//creating function
export const createBaseDocRule = (body) => axiosInstance.post(`${baseDocRuleURL}/create`, body);
//updating function
export const updateBaseDocRule = (id, body) => axiosInstance.patch(`${baseDocRuleURL}/update/${id}`, body);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${baseDocRuleURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataBaseDocRuleName = (e, cancelToken) =>
  axiosInstance.get(`${baseDocRuleURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
